import { ConnectionAddressObject } from "@origin-digital/address-lookup";

export enum AddressEntryType {
  NEW_ADDRESS = "NEW_ADDRESS",
  CURRENT_ADDRESS = "CURRENT_ADDRESS",
  EXTERNAL_ADDRESS = "EXTERNAL_ADDRESS",
  SAC_SELECTED_ADDRESS = "SAC_SELECTED_ADDRESS",
}

export interface IConnectionAddress extends ConnectionAddressObject {
  addressType: AddressEntryType;
}
